import { makeStyles, theme } from '@focaldata/cin-ui-components'

const useStyles = makeStyles()({
  paddingTop: {
    paddingTop: theme.spacing(1)
  }
})

export default useStyles
